// extracted by mini-css-extract-plugin
export var container = "_9b-0";
export var fallback = "_9b-5";
export var fallbackIcon = "_9b-6";
export var hidden = "_9b-2";
export var image = "_9b-3";
export var loaded = "_9b-4";
export var placeholder = "_9b-1";